import React, { FC, Fragment } from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Tab } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import ProductionOverview from 'components/production-overview/production-overview.component';
import WorkflowOverview from 'pages/lab-workflow/workflow-overview.component';

const PRODUCTION_TABS = ['overview', 'workflow'];

/**
 * DD-3800: the renamed Workflow menu item. Two tabs — the new Overview calendar
 * (default) and the existing Workflow page, unchanged, under its own tab.
 */
const Production: FC = () => {
    const { t: translate } = useTranslation(['production-overview', 'navigation']);
    const navigate = useNavigate();
    const { tab } = useParams<{ tab: string }>();
    const currentTab = tab && PRODUCTION_TABS.includes(tab) ? tab : 'overview';

    const handleTabChange = (_: unknown, nextTab: string) => {
        if (currentTab !== nextTab) {
            navigate(`/production/${nextTab}`);
        }
    };

    return (
        <Fragment>
            <Helmet>
                <title>{translate('navigation:PRODUCTION')} | Denthub</title>
            </Helmet>
            <TabContext value={currentTab}>
                <TabList onChange={handleTabChange} indicatorColor="primary" textColor="primary">
                    <Tab label={translate('production-overview:TAB_OVERVIEW')} value="overview" />
                    <Tab label={translate('production-overview:TAB_WORKFLOW')} value="workflow" />
                </TabList>

                <TabPanel sx={{ padding: 0, marginTop: 1 }} value="overview">
                    <ProductionOverview />
                </TabPanel>
                <TabPanel sx={{ padding: 0, marginTop: 1 }} value="workflow">
                    <WorkflowOverview />
                </TabPanel>
            </TabContext>
        </Fragment>
    );
};

export default Production;
